/* eslint-disable no-restricted-globals */

import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";
import {
  updateForwardedParams,
  createForwardParams,
  getSearchQuery,
} from "src/utils/urlParams";
import { forwardUpid, pushReroll, setParam } from "./utils";
import getStore from "src/utils/redux/store";
import goto from ".";

export type OffersParams = {
  claimedByEmail?: string;
  enrollmentResult?: string;
  userId?: string;
  acceptedCoursePackOffer?: boolean;
};

export type CollapsibleHeaderUrlParams = {
  showEmailReminder?: "noomPremium" | "supporterPlan" | "noomSummit" | false;
};

function isOffers() {
  return (
    location.pathname.startsWith("/add-ons/") ||
    location.pathname.startsWith("/en/add-ons/") ||
    location.pathname.startsWith("/offers/") ||
    location.pathname.startsWith("/en/offers/") ||
    location.pathname.startsWith("/in-app-offers/")
  );
}

const linkTo = {
  addOns({ claimedByEmail, enrollmentResult }: OffersParams) {
    forwardUpid(getStore());

    const queryParams = createForwardParams();

    setParam(queryParams, "claimedByEmail", claimedByEmail);
    setParam(queryParams, "enrollmentResult", enrollmentResult);

    return `/add-ons${getSearchQuery(queryParams)}`;
  },
  limitedOffer(productId: string) {
    return `${linkTo.addOns({})}#/limitedOffer/${productId}`;
  },
};

export default {
  noomPremium({
    claimedByEmail,
    enrollmentResult,
    acceptedCoursePackOffer,
  }: OffersParams) {
    updateForwardedParams({
      claimedByEmail,
      enrollmentResult,
      acceptedCoursePackOffer,
    });
    forwardUpid(getStore());

    goto.layer("noom-premium");
  },
  addOns({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder,
    });
    forwardUpid(getStore());

    goto.layer("addons");
  },
  limitedOffer(productId: string) {
    pushReroll(linkTo.limitedOffer(productId), isOffers);
  },

  fastForwardTrial({ showEmailReminder }: CollapsibleHeaderUrlParams) {
    updateForwardedParams({
      [CHECK_EMAIL_REMINDER_PARAM]: showEmailReminder,
    });
    forwardUpid(getStore());

    goto.layer(`fast-forward`);
  },
};
